"use client";

// React & Nextjs imports
import { useEffect, useRef } from "react";

// Model & Constants
import { UsStock } from "@/app/interface/global";

const IBKR_TO_TV_EXCHANGE = {
    ARCA: "AMEX",
    AMEX: "AMEX",
    NYSE: "NYSE",
    NASDAQ: "NASDAQ",
    BATS: "BATS",
    IEX: "IEX",
    CBOE: "CBOE",
    SMART: "NASDAQ",
} as const;
type IbkrToTvExchange = keyof typeof IBKR_TO_TV_EXCHANGE;
const DEFAULT_EXCHANGE = "NASDAQ";

type Props = {
    stockDetails: UsStock;
};

export default function TradingViewChart({ stockDetails }: Props) {
    const symbol = stockDetails?.symbol ?? "";

    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!containerRef.current || !symbol) return;

        // Clear previous widget
        containerRef.current.innerHTML = "";

        const script = document.createElement("script");
        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
        script.async = true;
        script.innerHTML = JSON.stringify({
            symbol: `${stockDetails?.ibkr_exchange && Object.keys(IBKR_TO_TV_EXCHANGE).includes(stockDetails?.ibkr_exchange) ? IBKR_TO_TV_EXCHANGE[stockDetails?.ibkr_exchange as IbkrToTvExchange] + ":" + symbol : DEFAULT_EXCHANGE + ":" + symbol}`,
            interval: "D",
            timezone: "Asia/Kolkata",
            theme: "light",
            style: "1",
            locale: "en",
            hide_top_toolbar: false,
            hide_legend: false,
            allow_symbol_change: false,
            save_image: false,
            studies: [],
            width: "101%",
            height: "101%",
            fullscreen: true,
        });

        containerRef.current.appendChild(script);
    }, [symbol]);

    return (
        <div
            ref={containerRef}
            className="tradingview-widget-container -ml-1 -mt-1 transition-all duration-200 ease-in"
        />
    );
}
